import { Text } from '$tablet-app/src/app/components/Text/Text';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import { format, isSameDay } from 'date-fns';
import React, { FC } from 'react';
import styled from 'styled-components/native';
import { MonthGridTileData } from './MonthGrid';

interface MonthGridTileProps {
  data?: MonthGridTileData;
  nextDay?: MonthGridTileData;
}

const MonthGridTile: FC<MonthGridTileProps> = (props) => {
  const { data, nextDay } = props;

  const date = data?.date;
  const success = data?.success;
  const today = !!(date && isSameDay(date, new Date()));

  if (!date) {
    return (
      <>
        <DateBox />
        <Line />
      </>
    );
  }

  const content = success ? (
    <FontAwesomeIcon icon="check" color="#10b981" />
  ) : (
    <Text weight="semibold">{format(date, 'd')}</Text>
  );

  const box = today ? (
    <TodayBox>{content}</TodayBox>
  ) : success ? (
    <TickedDateBox>{content}</TickedDateBox>
  ) : (
    <NumberDateBox>{content}</NumberDateBox>
  );

  const line = nextDay?.date ? (
    <Line success={success && nextDay.success} />
  ) : null;

  return (
    <>
      {box}
      {line}
    </>
  );
};

const DateBox = styled.View`
  height: 36px;
  width: 36px;

  justify-content: center;
  align-items: center;

  border-radius: 10px;

  border-width: 2px;
  border-color: transparent;
`;

const TodayBox = styled(DateBox)`
  border-color: #535af1;
`;

const NumberDateBox = styled(DateBox)`
  background-color: #f5f7f9;
`;

const TickedDateBox = styled(DateBox)`
  border-color: #10b981;
`;

const Line = styled.View<{ success?: boolean }>`
  height: 2px;

  flex: 1;

  ${({ success }) => (success ? `background-color: #10b981;` : '')}
`;

export default MonthGridTile;
